import Component from './Launch.vue';

export default {
  install(Vue) {
    Vue.component('BkfActionLaunch', Component);
  },
};
